import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AudioTransloaditUpload from '../../../../../../components/AudioTransloaditUpload';
import EditableCaption from '../../../../components/EditableCaption';

const editorOptions = {
  disableReturn: true,
  toolbar: {
    buttons: [
      'bold',
      'italic',
      'superscript',
      'subscript',
      { name: 'justifyLeft', contentDefault: '<i class="icon-paragraph-left"></i>' },
      { name: 'justifyCenter', contentDefault: '<i class="icon-paragraph-center"></i>' },
      { name: 'justifyRight', contentDefault: '<i class="icon-paragraph-right"></i>' },
      { name: 'anchor', contentDefault: '<i class="icon-link"></i>' }
    ]
  }
};

class AudioUploadSettings extends Component {
  static contextTypes = {
    dispatch: PropTypes.func
  };

  onCaptionChange = itemId => (text) => {
    this.context.dispatch('UPDATE_ITEM_DATA', {
      _id: itemId,
      caption: text
    });
  };

  newUploadDone = blockItem => (mp3AudioUrl) => {
    this.context.dispatch('UPDATE_ITEM_MEDIA', {
      _id: blockItem.items[0]._id,
      media: {
        audio: {
          src: mp3AudioUrl,
          isProcessing: false
        }
      }
    });
  };

  renderCaption(item) {
    const caption = item.caption;

    return (
      <EditableCaption
        wrapperClassName="block-video__caption brand--body brand--linkColor brand--linkColor"
        text={caption}
        placeholder="Add a caption"
        component="figcaption"
        editable={true}
        onChange={this.onCaptionChange(item._id, this.context.dispatch)}
        editorOptions={editorOptions}
      />
    );
  }

  render() {
    return (
      <div className="AudioUploadContainer">
        <AudioTransloaditUpload
          courseId={this.props.courseId}
          blockItem={this.props.blockItem}
          audioUrl={this.props.blockItem.items[0].media.audio.src}
          uploadDone={this.newUploadDone(this.props.blockItem)}
          cardId={this.props.cardId}
        />
        {this.renderCaption(this.props.blockItem.items[0])}
      </div>
    );
  }
}

export default AudioUploadSettings;
